import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { IInformationDialogOptions } from './information-dialog-options.interface';
// import { UtilsService } from '../../index';

@Component({
  selector: 'app-information-dialog',
  // encapsulation: ViewEncapsulation.None,
  templateUrl: 'information-dialog.component.html',
  styleUrls: ['information-dialog.component.scss']
})

export class InformationDialogComponent implements OnInit, OnDestroy {
  dialog: MatDialogRef<any>;
  modalOptions!: IInformationDialogOptions;

  constructor(
    public dialogRef: MatDialogRef<any>,
    // private _utilsService: UtilsService
  ) {
    this.dialog = dialogRef;
  }

  ngOnInit() {
    this.modalOptions.title = this.modalOptions.title ?? 'Informacion';
    this.modalOptions.message = this.modalOptions.message ?? 'Mensaje';
    this.modalOptions.message = this.modalOptions.message.replace("\n", '<br>');
    this.modalOptions.message = this.modalOptions.message.replace('\n', '<br>');
    this.modalOptions.closeButtonLabel = this.modalOptions.closeButtonLabel ?? 'Cerrar';
    // this._utilsService.disableBodyScroll();
  }

  ngOnDestroy() {
    // this._utilsService.enableBodyScroll();
  }
}
